import { lazy, type ReactElement } from 'react';

export interface WorkflowAutomationRouteDefinition {
  capabilityPath: string;
  label: string;
  element: ReactElement;
}

export const WorkflowDesigner = lazy(() =>
  import('./WorkflowDesigner').then((module) => ({ default: module.WorkflowDesigner }))
);

export const WORKFLOW_AUTOMATION_ROUTE_DEFINITIONS: readonly WorkflowAutomationRouteDefinition[] = [
  {
    capabilityPath: '/workflows/designer',
    label: 'Workflow Designer',
    element: <WorkflowDesigner />,
  },
  {
    capabilityPath: '/workflows/designer/:id',
    label: 'Workflow Designer',
    element: <WorkflowDesigner />,
  },
];
